import styled from '@emotion/styled';

export const CircleContainer = styled.div`
  postion: relative;
`;

export const FaqBtn = styled.div`
  padding: 5px;
  width: 44px;
  height: 44px;
  text-align: center;
  background-color: #7a68e9;
  color: ${({ theme }) => theme.white};
  position: fixed;
  border-radius: 50%;
  font-size: 20px;
  z-index: 100;
  font-weight: bold;
  bottom: 5%;
  right: 2%;
  cursor: pointer;
  color: white;
`;

export const FaqBtnExpand = styled.div`
  padding: 8px;
  width: 100px;
  cursor: pointer;
  text-align: center;
  background-color: #7a68e9;
  color: ${({ theme }) => theme.white};
  position: fixed;
  border-radius: 20px;
  font-size: 17px;
  font-weight: 400;
  bottom: 5%;
  z-index: 100;
  right: 2%;
  cursor: pointer;
  color: white;
`;

export const ModalBtn = styled.div`
  padding: 5px;
  width: 44px;
  height: 44px;
  text-align: center;
  background-color: #242528;
  color: ${({ theme }) => theme.white};
  position: absolute;
  border-radius: 50%;
  font-size: 20px;
  font-weight: bold;
  bottom: 3%;
  right: 3%;
  cursor: pointer;
`;

export const FaqModal = styled.div`
  display: grid;
  background-color: #242528;
  border-radius: 12px;
  color: ${({ theme }) => theme.white};
  padding: 20px;
  position: absolute;
  bottom: 10%;
  right: 3%;
`;

export const ModalListBtn = styled.button`
  background: transparent;
  // width: 100%;
  text-align: left;
  border: none;
  color: rgba(255, 255, 255, 0.87);
`;

export const LabelInput = styled.div`
  font-weight: 600;
  color: #7b7e83;
  font-size: 14px;
`;

export const Submit = styled.button`
  border: none;
  border-radius: 50px;
  background: #7a68e9;
  padding: 12px 32px;
  color: #fff;
`;

export const FileUpload = styled.button`
  background: transparent;
  border: none;
`;

//generate custom input field
export const CustomInput = styled.input`
  border: none;
  border-bottom: 1px solid #7b7e83;
  background: transparent;
  color: #000;
  padding: 10px 0;
  width: 100%;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 600;
`;
